import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../../../services/api/error";

import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
import { api } from "../../../../../../services/api/api";
import TechnicianTimeTypeForm from "../../../../../../components/data/time-type/TechnicianTimeTypeForm";

/**
* TechnicianTimeTypesAdminActions: Admin actions for technician time types
* @param type - Time type data
* @param onChange - On change event
*/
export default function TechnicianTimeTypesAdminActions({
  type,
  onChange
}: {
  type: EasyTech.TimeType,
  onChange: () => void
}) {
  /**
  * updateType: update technician time type information
  * @param type - time type data to update
  */
  const updateType = (type: EasyTech.TimeType): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (type.translations) {
        type.translations = type.translations.filter((el: EasyTech.Translation) => {
          const cond = !el.label;
          return !cond;
        });
      }
      if (type && type.label && type.id) {
        // Format the data for the API
        const formattedData = {
          label: type.label,
          visibility: type.visibility || "ALL",
          translations: type.translations?.map((translation: any) => ({
            language: {
              id: translation.language.id
            },
            label: translation.label,
            isDefault: false
          })) || []
        };

        api.put("admin/technician_time_types/"+type.id, formattedData).then((ret) => {
          onChange();
          toast.success("Technician time type updated");
          return resolve();
        }).catch((error: any) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la mise à jour du type d'indisponibilité" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  return(
    <div className="admin-wo-actions">
      <EditCreateDrawer data={(type as EasyTech.TimeType)}
        entityName="Technician time type"
        FormComponent={TechnicianTimeTypeForm}
        isNotCreatable={true}
        onSubmit={updateType} />
    </div>
  );
}
